<template>
  <order-list :is-order-status="0"></order-list>
</template>

<script>
import OrderList from './components/OrderList'
export default {
  name: 'Unpaid',
  components: {
    OrderList
  }
}
</script>
